import React, { Component } from 'react';
import PropTypes from 'prop-types'
import classNames from 'classnames';
import utils from './utils';

function partial(fn, ...args) {
  return fn.bind(fn, ...args);
}

class CountryList extends Component {
  static propTypes = {
    setFlag: PropTypes.func,
    countries: PropTypes.arrayOf(PropTypes.object),
    inputTop: PropTypes.number,
    inputOuterHeight: PropTypes.number,
    preferredCountries: PropTypes.arrayOf(PropTypes.object),
    highlightedCountry: PropTypes.number,
    changeHighlightCountry: PropTypes.func,
    showDropdown: PropTypes.bool,
    isMobile: PropTypes.bool,
    onDropdownClose: PropTypes.func, // New prop for handling dropdown close
  };

  constructor(props) {
    super(props);
    this.listRef = React.createRef();
    this.handleMouseOver = this.handleMouseOver.bind(this);
    this.setFlag = this.setFlag.bind(this);
    this.appendListItem = this.appendListItem.bind(this);
    this.setDropdownPosition = this.setDropdownPosition.bind(this);
    this.handleClickOutside = this.handleClickOutside.bind(this);
  }

  componentDidMount() {
    document.addEventListener('mousedown', this.handleClickOutside);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.showDropdown && this.props.showDropdown) {
      this.setDropdownPosition();
    }
  }

  handleClickOutside(event) {
    if (this.listRef.current && !this.listRef.current.contains(event.target) && this.props.showDropdown) {
      if (this.props.onDropdownClose) {
        this.props.onDropdownClose();
      }
    }
  }

  setDropdownPosition() {
    if (!this.listRef.current) return;

    utils.removeClass(this.listRef.current, 'hide');

    const inputTop = this.props.inputTop;
    const windowTop = (window.pageYOffset !== undefined) ?
      window.pageYOffset :
      (document.documentElement || document.body.parentNode || document.body).scrollTop;
    const windowHeight = window.innerHeight || document.documentElement.clientHeight ||
      document.body.clientHeight;
    const inputOuterHeight = this.props.inputOuterHeight;
    const countryListOuterHeight = utils.getOuterHeight(this.listRef.current);
    const dropdownFitsBelow =
      (inputTop + inputOuterHeight + countryListOuterHeight < windowTop + windowHeight);
    const dropdownFitsAbove = (inputTop - countryListOuterHeight > windowTop);

    // dropdownHeight - 1 for border
    const cssTop = (!dropdownFitsBelow && dropdownFitsAbove) ?
      `-${(countryListOuterHeight - 1)}px` : '';

    this.listRef.current.style.top = cssTop;
    this.listRef.current.setAttribute('class', 'country-list');
  }

  setFlag(iso2) {
    this.props.setFlag(iso2);
    if (this.props.onDropdownClose) {
      this.props.onDropdownClose();
    }
  }

  appendListItem(countries, isPreferred = false) {
    const preferredCountriesCount = this.props.preferredCountries.length;

    return countries.map((country, index) => {
      const actualIndex = isPreferred ? index : index + preferredCountriesCount;
      const countryClassObj = {
        country: true,
        highlight: (this.props.highlightedCountry === actualIndex),
        preferred: isPreferred,
      };
      const countryClass = classNames(countryClassObj);
      const keyPrefix = isPreferred ? 'pref-' : '';

      return (
        <li
          key={ `${keyPrefix}${country.iso2}` }
          className={ countryClass }
          data-dial-code={ country.dialCode }
          data-country-code={ country.iso2 }
          onMouseOver={ this.props.isMobile ? null : this.handleMouseOver }
          onClick={ partial(this.setFlag, country.iso2) }
        >
          <div className="flag-box">
            <div className={ `iti-flag ${country.iso2}` } />
          </div>
          <span className="country-name">{ country.name }</span>
          <span className="dial-code">+{ country.dialCode }</span>
        </li>
      );
    });
  }

  handleMouseOver(e) {
    if (e.currentTarget.getAttribute('class').indexOf('country') > -1) {
      const selectedIndex = utils.retrieveLiIndex(e.currentTarget);
      this.props.changeHighlightCountry(true, selectedIndex);
    }
  }

  render() {
    const className = classNames({
      'country-list': true,
      hide: !this.props.showDropdown,
    });

    const preferredCountries = this.props.preferredCountries;
    let preferredOptions = null;
    let divider = null;

    if (preferredCountries.length) {
      preferredOptions = this.appendListItem(preferredCountries, true);
      divider = (
        <div className="divider" />
      );
    }

    const options = this.appendListItem(this.props.countries);

    return (
      <ul
        ref={ this.listRef }
        className={ className }
      >
        { preferredOptions }
        { divider }
        { options }
      </ul>
    );
  }
}

export default CountryList;
